import api from "./api";
import { errorHandling } from "./error.handling";

// const basePath = `${process.env.REACT_APP_API_VEHICLE_BASE_URL}/v1/vehiclemodel`;
const basePath = "https://nc8.olharfixo.com.br/Vehicles/api/v3";


async function create(payload) {
  try {
    let response = await api.post(`${basePath}/models`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "modelsService.create"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "modelsService.create");
    return null;
  }
}

async function update(payload) {
  try {
    let response = await api.put(`${basePath}/models/${payload.id}`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "modelsService.update"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "modelsService.update");
    return null;
  }
}

async function list() {
  try {
    let response = await api.get(`${basePath}/models`);
    let treated = errorHandling.handleResponse(
      response,
      "modelsService.list"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "modelsService.list");
    return null;
  }
}

async function findByAutomaker(automakerId, categoryId) {

  try {
    let url = `${basePath}/models?automakerId=${automakerId}`;
    if (categoryId) {
      url += `&categoryId=${categoryId}`;
    }
    let response = await api.get(url);
    let treated = errorHandling.handleResponse(
      response,
      "modelsService.findByAutomaker"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "modelsService.findByAutomaker");
    return null;
  }
}

export const modelsService = {
  create,
  update,
  list,
  findByAutomaker,
};
